import { render, staticRenderFns } from "./Profile-Home.vue?vue&type=template&id=e315cbc2&scoped=true&"
import script from "./Profile-Home.vue?vue&type=script&lang=js&"
export * from "./Profile-Home.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Home.vue?vue&type=style&index=0&id=e315cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e315cbc2",
  null
  
)

export default component.exports